import React, { useState, useEffect, useContext } from 'react';
// import { LoginSocialGoogle } from 'reactjs-social-login';
// import md5 from 'md5';
import { TYPE_SUCCESS, TYPE_FAIL, INTERVAL } from 'assets/constants/Constants';
import Spinner from 'components/Spinner';
import AuthContext from 'context/AuthProvider';
import ShowToast from 'components/ShowToast';
import { EYE_ICON, EYE_SLASH_ICON } from 'assets/constants/Icons';
import { getMetaDataCall } from "lib/axiosUtils";
// import { createNewUserAuthenticatedByGoogle, findUserNameCall, getRoleCall, getMetaDataCall } from "lib/axiosUtils";

import vector from "../../assets/images/Vector.svg";

const FEATURES = [
    {
        id: 'opportunity-map',
        title: 'Your AI Opportunity MAP',
        description:
            'Discover where AI agents can create the biggest impact for your organization.',
    },
    {
        id: 'agent-explorer',
        title: 'Access to our Agent explorer',
        description:
            'Discover where AI agents can create the biggest impact for your organization.',
    },
    {
        id: 'demo-days',
        title: 'Invite only Demo-Days',
        description: 'Attend private demo sessions featuring top agents',
    },
];

function CheckCircleIcon() {
    return (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="9" strokeWidth="2" />
            <path d="M8.5 12.5L10.75 14.75L15.5 10" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

const LoginPage = (props) => {
    const context = useContext(AuthContext);
    const [isLoading, setIsLoading] = useState(true);
    const [input, setInput] = useState({});
    const [errors, setErrors] = useState({});
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        localStorage.setItem("loginURL", window.location.href);
        if (context.isAuthenticated()) {
            window.location.href = "/index.html";
        }
        setIsLoading(false);
    }, [context]);

    const handleInputChange = (e) => {
        setInput({
            ...input,
            [e.target.name]: e.target.value
        });
    };

    const handleShowPasswordClick = (event) => {
        setShowPassword(prev => !prev);
    }

    const formValidate = () => {
        let errors = {};
        let isValid = true;

        if (!input["userName"]) {
            isValid = false;
            errors["userName"] = "Please enter your username.";
        }

        if (!input["password"]) {
            isValid = false;
            errors["password"] = "Please enter your password.";
        }
        setErrors(errors);
        return isValid;
    }

    const handleSignIn = async (e) => {
        e.preventDefault();
        try {
            if (formValidate()) {
                setIsLoading(true);
                const responseData = await context.signIn(input.userName, input.password);
                if (responseData?.statusCode === 200 && responseData?.data?.result?.success) {

                    // Role was already fetched inside AuthProvider.signIn — reuse it
                    // instead of making a second, redundant network round trip.
                    const metaData = await getMetaDataCall({}, {});
                    localStorage.setItem("metadata", JSON.stringify(metaData.data.result));

                    if (responseData.roleData?.data?.success) {
                        // AuthProvider.signIn already persisted "username" to
                        // localStorage — the static navbar reads it from there.
                        ShowToast('Login successful!', TYPE_SUCCESS, INTERVAL, props, "");
                        window.location.href = "/index.html";
                    }
                } else {
                    setIsLoading(false);
                    ShowToast(responseData?.data?.message || 'Something went wrong', TYPE_FAIL, INTERVAL, props);
                }
            }
        } catch (err) {
            setIsLoading(false);
            ShowToast('Authentication failed! Invalid username or password.', TYPE_FAIL, INTERVAL, props);
        }
    };

    const handleSignUp = () => {
        window.location.href = "/signup-page";
    };

    // const checkIfNewUser = async (username) => {
    //     const findUserByUsernameResponse = await findUserNameCall({}, {}, username);

    //     if (findUserByUsernameResponse?.statusCode === 200) {
    //         if (findUserByUsernameResponse?.data?.result.length === 0) {
    //             return true;
    //         }
    //         else if ((findUserByUsernameResponse?.data?.result.length > 0) && (findUserByUsernameResponse?.data?.result[0]?.username === username)) {
    //             return false;
    //         }
    //     }

    //     return null;
    // };

    // const generatePasswordForGoogleUser = (email) => {
    //     const initialCharactersOfEmail = email.slice(0, 3);
    //     const characterCodesOfInitialCharacters = () => {
    //         const arrayOfCharacterCodes = [];
    //         initialCharactersOfEmail.split('').forEach((character) => {
    //             arrayOfCharacterCodes.push(character.charCodeAt(0));
    //         });

    //         return arrayOfCharacterCodes.join('');
    //     };

    //     return `MAi_GAuth_${initialCharactersOfEmail}@${characterCodesOfInitialCharacters()}`;
    // }

    // const createNewUserAuthenticatedUsingGoogle = async (userData) => {
    //     const autoGeneratedPassword = generatePasswordForGoogleUser(userData?.email);
    //     const requestData = {
    //         userFirstName: userData?.given_name ? userData?.given_name : '',
    //         userLastName: userData?.family_name ? userData?.family_name : '',
    //         userEmailId: userData?.email,
    //         userPhoneNumber: '',
    //         userName: userData?.email,
    //         userPassword: md5(autoGeneratedPassword),
    //         displayPass: '',
    //         userRole: '685bd47616683abdf8603b70',
    //         userLocation: '',
    //         googleAccessToken: userData?.access_token,
    //         signupMethod: 'self-register_google-signup'
    //     };

    //     return await createNewUserAuthenticatedByGoogle({}, requestData);
    // }

    // const loginUserAuthenticatedUsingGoogle = async (email) => {
    //     const autoGeneratedPassword = generatePasswordForGoogleUser(email);
    //     setIsLoading(true);

    //     const loginResponse = await context.signIn(email, autoGeneratedPassword);

    //     if (loginResponse?.statusCode === 200 && loginResponse?.data?.result?.success) {
    //         const userRole = await getRoleCall({}, {}, loginResponse?.data?.result?.result?.role);
    //         const metaData = await getMetaDataCall({}, {});

    //         localStorage.setItem('metadata', JSON.stringify(metaData?.data?.result));
    //         if (userRole?.data?.success) {
    //             // AuthProvider.signIn already persisted "username" to
    //             // localStorage — the static navbar reads it from there.
    //             ShowToast('Login Successful!', TYPE_SUCCESS, INTERVAL, props);
    //             window.location.href = "/index.html";
    //         }
    //     }
    //     else {
    //         setIsLoading(false);
    //         ShowToast('Something went wrong', TYPE_FAIL, INTERVAL, props);
    //     }
    // }

    // const onGoogleLoginResolve = async (data) => {
    //     setIsLoading(true);
    //     const isNewUser = await checkIfNewUser(data?.email);

    //     if (isNewUser) {
    //         const res = await createNewUserAuthenticatedUsingGoogle(data);
    //         if (res?.data?.result?._id) {
    //             await loginUserAuthenticatedUsingGoogle(data.email);
    //         }
    //     } else if (isNewUser === false) {
    //         await loginUserAuthenticatedUsingGoogle(data.email);
    //     } else {
    //         setIsLoading(false);
    //         ShowToast('Something went wrong', TYPE_FAIL, INTERVAL, props);
    //     }
    // }

    // const onGoogleLoginReject = (error) => {
    //     console.error('Error while logging in with Google: ', error);
    // }

    return (
        <>
            {
                isLoading ? (
                    <Spinner />
                ) : (
                    <section className="signup-page">
                        <div className="signup-card">
                            {/* Left — glass info panel */}
                            <div className="signup-panel-left">
                                <div className="signup-panel-left__intro">
                                    <h2 className="signup-panel-left__heading">
                                        The AI gap is widening.
                                        <br />
                                        100 enterprises get in first
                                    </h2>
                                    <p className="signup-panel-left__subtext">
                                        Hence early access is limited to 100 enterprises, enabling us to
                                        provide a more personalized experience
                                    </p>
                                </div>

                                <ul className="signup-panel-left__features">
                                    {FEATURES.map((feature) => (
                                        <li className="feature-row" key={feature.id}>
                                            <span className="feature-row__icon">
                                                <CheckCircleIcon />
                                            </span>
                                            <div className="feature-row__body">
                                                <p className="feature-row__title">{feature.title}</p>
                                                <p className="feature-row__desc">{feature.description}</p>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            {/* Right — form panel */}
                            <div className="signup-panel-right">
                                <div className="signup-panel-right__header">
                                    <h1 className="signup-panel-right__title">Login to your account</h1>
                                    <p className="signup-panel-right__subtitle">
                                        Welcome back!
                                    </p>
                                </div>
                                <form className="signup-form" action="!#" style={{ width: '100%' }}>
                                    <style>
                                        {`
                                        .google-login-wrapper > div {
                                            width: 100% !important;
                                        }
                                        `}
                                    </style>
                                    <div className="form-field">
                                        <label className="form-field__label" htmlFor="userName">Username</label>
                                        <input
                                            type="text"
                                            name="userName"
                                            id="userName"
                                            placeholder="Enter Your Username"
                                            className={`form-field__input${errors.userName ? ' form-field__input--error' : ''}`}
                                            onChange={handleInputChange}
                                        />
                                        {errors.userName && <span className="form-field__error">{errors.userName}</span>}
                                    </div>

                                    <div className="form-field" style={{ marginBottom: '15px' }}>
                                        <label className="form-field__label" htmlFor="password">Password</label>
                                        <div style={{ position: 'relative', width: '100%' }}>
                                            <input
                                                type={showPassword ? "text" : "password"}
                                                name="password"
                                                id="password"
                                                placeholder="Enter Password"
                                                className={`form-field__input${errors.password ? ' form-field__input--error' : ''}`}
                                                onChange={handleInputChange}
                                                style={{ paddingRight: '40px' }}
                                            />
                                            <div className="icon" style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }}>
                                                <i className={showPassword ? EYE_SLASH_ICON : EYE_ICON} onClick={handleShowPasswordClick} title="View password" style={{ color: '#666' }}></i>
                                            </div>
                                        </div>
                                        {errors.password && <span className="form-field__error">{errors.password}</span>}
                                    </div>

                                    <div className="option_div" style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '15px' }}>
                                        <div className="forget_div">
                                            <a href="/forget-password" style={{ color: '#666', fontSize: '13px', textDecoration: 'none' }}>Forgot password?</a>
                                        </div>
                                    </div>

                                    <div className="signup-form__actions" style={{ marginTop: '0' }}>
                                        <button onClick={handleSignIn} className="cta-button">
                                            Login
                                            <img
                                                src={vector}
                                                alt=""
                                                className="cta-button__icon"
                                            />
                                        </button>
                                    </div>



                                    {process.env.REACT_APP_GOOGLE_CLIENT_ID && (
                                        <div className='google-login-wrapper' style={{ width: '100%' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', margin: '24px 0', width: '100%', justifyContent: 'center' }}>
                                                {/* <LoginSocialGoogle
                                                    client_id={process.env.REACT_APP_GOOGLE_CLIENT_ID}
                                                    scope='profile email'
                                                    onLoginStart={() => { }}
                                                    onResolve={({ provider, data }) => onGoogleLoginResolve(data)}
                                                    onReject={(error) => onGoogleLoginReject(error)}
                                                >
                                                    <button id='login-with-google-button' onClick={(event) => { event.preventDefault(); }} style={{ width: '100%', padding: '10px', border: '1px solid black', borderRadius: '5px', backgroundColor: 'transparent' }} >Login With Google</button>
                                                </LoginSocialGoogle> */}
                                                <div style={{ flex: 1, height: '1px', backgroundColor: '#e8e0c2' }}></div>
                                                <span style={{ padding: '0 15px', color: '#999', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.08em' }}>OR</span>
                                                <div style={{ flex: 1, height: '1px', backgroundColor: '#e8e0c2' }}></div>
                                            </div>
                                        </div>
                                    )}

                                    {!process.env.REACT_APP_GOOGLE_CLIENT_ID && (
                                        <div style={{ display: 'flex', alignItems: 'center', margin: '24px 0', width: '100%', justifyContent: 'center' }}>
                                            <div style={{ flex: 1, height: '1px', backgroundColor: '#e8e0c2' }}></div>
                                            <span style={{ padding: '0 15px', color: '#999', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.08em' }}>OR</span>
                                            <div style={{ flex: 1, height: '1px', backgroundColor: '#e8e0c2' }}></div>
                                        </div>
                                    )}

                                    <div className="signup-form__actions" style={{ marginTop: '0', paddingTop: '0' }}>
                                        <button id='signup-button' onClick={(e) => { e.preventDefault(); handleSignUp(); }} className="cta-button">
                                            Get early access
                                            <img src={vector} alt="" className="cta-button__icon" />
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </section>
                )
            }
        </>
    );
}

export default LoginPage;